import { Dialog, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';
export const HelixDraggableContainer = styled(Dialog)(() => ({
    position: 'initial',
    zIndex: 1300,
    '& .MuiPaper-root': {
        borderRadius: '1.5rem',
        minWidth: '410px',
        minHeight: '200px',
        right: '0',
        bottom: '0',
    },
}));
export const HelixDraggableContainerTitle = styled(DialogTitle)(() => ({
    cursor: 'move',
    padding: 0,
}));
export const HelixDraggableContainerFooter = styled(DialogActions)(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0.5rem 1.5rem  1rem 1.5rem',
    gap: '1rem',
    '& button': {
        margin: 0,
    },
    '& > *:not(:first-child)': {
        marginLeft: '0',
    },
    cursor: 'default',
}));
export const HelixDraggableContainerSubHeader = styled(DialogActions)(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0',
    cursor: 'default',
}));
export const HelixDraggableContainerSidePanel = styled(DialogContent)(() => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 1.5em',
    scrollbarWidth: 'thin',
    borderLeft: '1px solid #e0e0e0',
    width: '300px',
}));
export const HelixDraggableContainerContent = styled(DialogContent)(() => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 1.5em',
    gap: '1rem',
    scrollbarWidth: 'thin',
    cursor: 'default',
    alignItems: 'center',
    flexWrap: 'nowrap',
}));
